
import { defineComponent, onMounted, reactive } from 'vue'

// realisations
import { security } from '@/core/realisations/security.realisation'

// types
import { SecurityHistoryItemT } from '@/core/types/security.types'

export default defineComponent({
    props: {
        identifier: {
            type: String,
            default: null,
        },
        type: {
            type: Number,
            default: null,
        },
    },
    setup(props, { emit }) {
        const state = reactive({
            is_loading: false,
            //
            history: [] as SecurityHistoryItemT[],
        })

        const loadSbHistory = async () => {
            try {
                state.is_loading = true

                const params = {
                    identifier: props.identifier,
                    type: props.type,
                }

                const response: any = await security.getSbHistory(params)
                state.history = response.data
            } catch (error) {
                console.log(error)
            } finally {
                state.is_loading = false
            }
        }

        const getCheckOrTimesIcon = (is_accepted: boolean) => {
            return `fas ${
                is_accepted ? 'fa-check text-green-500 mr-4' : 'fa-times text-red-500 mr-4'
            }`
        }

        const getTitle = (is_accepted: boolean) => {
            let result = 'Ранее '

            switch (props.type) {
                case 1:
                    result += 'физ. лицу было '
                    break
                case 2:
                    result += 'юр. лицу было '
                    break
                case 3:
                    result += 'авто было '
                    break
            }

            result += is_accepted ? 'разрешено' : 'отказано'

            return result
        }

        const getClass = (is_accepted: boolean) => {
            return `SbHistory__item ${is_accepted ? 'bg-green-50' : 'bg-red-50'}`
        }

        onMounted(() => {
            loadSbHistory()
        })

        return {
            state,
            getCheckOrTimesIcon,
            getTitle,
            getClass,
        }
    },
})
